
import { Vue, Component, Prop } from "vue-property-decorator";
import {
  isGlobalVariable,
  getGlobalVariableFromInputValue,
  parseControlTypeToVariableType
} from "./lib/utils";
import { ColorPickerType } from "@/types/colors";
import Icon from "@/components/UI/Icon.vue";
import VariableChooser from "@/oxygen/variables/VariableChooser.vue";
import VariableChip from "@/oxygen/variables/VariableChip.vue";

@Component({
  components: { VariableChip, Icon, VariableChooser }
})
export default class VariableBoundInput extends Vue {
  @Prop({ default: undefined })
  value!: unknown;

  @Prop({ default: "Variable" })
  name!: string;

  @Prop({ default: "text" })
  type!: string;

  @Prop()
  path!: string;

  @Prop()
  colorType?: ColorPickerType;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: true })
  canCreate!: boolean;

  @Prop()
  variableToIgnore?: string;

  get isGlobalVariable() {
    return isGlobalVariable(this.value);
  }

  get globalVariable() {
    return getGlobalVariableFromInputValue(this.value);
  }

  get variableType() {
    return parseControlTypeToVariableType(this.type);
  }

  setVariable(value: unknown) {
    this.$emit("input", value);
  }
}
